// Utility to play a beep sound using HTML5 Audio
import beepSound from '../assets/sound/digital-clock-beep-5s.wav';

const audio = new Audio(beepSound);

export const playCountdownBeep = () => {
    // If it's already playing, we might want to let it continue if it's a sequence,
    // or restart it if it's a single beep.
    // Assuming it's a 5s sequence based on the name, we should just play it.
    // But if we want to ensure it starts fresh:
    audio.currentTime = 0;
    audio.play().catch(err => console.error('Failed to play sound:', err));
};

export const stopCountdownBeep = () => {
    audio.pause();
    audio.currentTime = 0;
};
